import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from "vue-baidu-map"
import ElementUI from 'element-ui';
import 'babel-polyfill'
import TreeTable from 'vue-table-with-tree-grid'
import { message } from './util/resetMessage'
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.component('tree-table', TreeTable)
Vue.prototype.$message = message;

Vue.use(BaiduMap, {
	ak: "stReesPKh9i1xZ2gHBcD8DRet85XCfrY"
});

//注释所有的console.log
//console.log=function(){}
import echarts from 'echarts'

Vue.prototype.$echarts = echarts;


Vue.prototype.$mqttval = (loopurl, node) => {

	return store.getters.mqttVal(loopurl + '/' + node)
}


Vue.config.productionTip = false

let vue = new Vue({
	router,
	store,

	render: function (h) {
		return h(App)
	}
});
vue.$mount('#app')
export const vueInstance = vue
export const storeInstance = store
